import React from 'react';

import type { ILead } from 'src/services/api';
import ExpandableItem from 'src/components/lead-sidebar/LeadSidebarExpandableItem';
import { FlexColumn } from 'src/components/flex';
import FactRow from 'src/components/lead-sidebar/FactRow';
import LeadFactsList from 'src/components/lead-sidebar/LeadFactsList';
import EditFactButton from 'src/components/lead-sidebar/EditFactButton';
import { useJustAddedKeys } from 'src/components/lead-sidebar/just-added-facts-context';
import { getDisplayedFacts } from 'src/components/lead-sidebar/displayed-lead-facts';
import { getDisplayedSmartFields } from 'src/components/lead-sidebar/displayed-smart-fields';

type Props = {
    lead: ILead;
};

export default function LeadInfo({ lead }: Props) {
    const displayedUUID = lead.uuid.slice(0, 10) + '...';
    const hasFacts = getDisplayedFacts(lead).length > 0;
    const smartFields = getDisplayedSmartFields(lead);

    const justAddedKeys = useJustAddedKeys();

    return (
        <ExpandableItem
            title="Lead Info"
            defaultExpanded={
                hasFacts || smartFields.length > 0 || !!lead.phone_number || !!lead.email
            }
        >
            <FlexColumn rowGap={1.5} pb={1}>
                {lead.phone_number && (
                    <FactRow
                        label="Phone"
                        value={lead.phone_number}
                        factKey="phone"
                        isJustAdded={justAddedKeys.has('phone')}
                        editButton={
                            <EditFactButton
                                leadUuid={lead.uuid}
                                title="Phone"
                                testId="phone_number"
                                factKey="phone_number"
                                value={lead.phone_number}
                            />
                        }
                    />
                )}
                {lead.email && (
                    <FactRow
                        label="Email"
                        value={lead.email}
                        factKey="email"
                        isJustAdded={justAddedKeys.has('email')}
                        editButton={
                            <EditFactButton
                                leadUuid={lead.uuid}
                                title="Email"
                                testId="email"
                                factKey="email"
                                value={lead.email}
                            />
                        }
                    />
                )}
                <LeadFactsList lead={lead} />
                {smartFields.map(({ key, label, value }) => (
                    <FactRow key={key} label={label} value={value} factKey={`smart-${key}`} />
                ))}
                <FactRow
                    label="Reffie ID"
                    value={displayedUUID}
                    copyText={lead.uuid}
                    factKey="reffie-id"
                />
            </FlexColumn>
        </ExpandableItem>
    );
}
